import { css } from "styled-components";
import { breakPointArrayCleaner, responsiveArraySpreader } from "./utils";

var verticalSpace = function verticalSpace(props) {
  props.mt = breakPointArrayCleaner(props.mt ? props.mt : false);
  props.mb = breakPointArrayCleaner(props.mb ? props.mb : false);
  props.my = breakPointArrayCleaner(props.my ? props.my : false);
  props.pt = breakPointArrayCleaner(props.pt ? props.pt : false);
  props.pb = breakPointArrayCleaner(props.pb ? props.pb : false);
  props.py = breakPointArrayCleaner(props.py ? props.py : false);

  return css(["", ""], function (props) {
    return responsiveArraySpreader(function (mt, mb, my, pt, pb, py) {
      return css(["", " margin-top:", ";margin-bottom:", ";", " padding-top:", ";padding-bottom:", ";"], my && css(["margin-top:", "rem;margin-bottom:", "rem;"], my, my), mt ? mt + "rem" : "none", mb ? mb + "rem" : "none", py && css(["padding-top:", "rem;padding-bottom:", "rem;"], py, py), pt ? pt + "rem" : "none", pb ? pb + "rem" : "none");
    }, props.mt, props.mb, props.my, props.pt, props.pb, props.py);
  });
};

var background = function background(props) {
  props.background = breakPointArrayCleaner(props.background ? props.background : false);

  return css(["", ""], function (props) {
    return responsiveArraySpreader(function (value) {
      return value && css(["background:", ";"], props.theme.background);
    }, props.background);
  });
};

var softRightCorner = function softRightCorner(props) {
  props.softRightCorner = breakPointArrayCleaner(props.softRightCorner ? props.softRightCorner : false);

  return css(["", ""], function (props) {
    return responsiveArraySpreader(function (value) {
      return value && css(["border-top-right-radius:", "rem;"], props.theme.softCornerRadius);
    }, props.softRightCorner);
  });
};

export var globalStyleMixins = {
  verticalSpace: verticalSpace,
  background: background,
  softRightCorner: softRightCorner
};